/* ======================================================================== */
/* 4. PJAX Init New Page */
/* ======================================================================== */
function PJAXInitNewPage(data) {

	return new Promise(function (resolve, reject) {
		const
			promises = [
				PJAXUpdateAdminBar(data),
				PJAXUpdateLanguageSwitcher(data),
				PJAXUpdateBodyClasses(data),
				PJAXUpdateHeaderClasses(data),
				PJAXUpdateHead(data)
			],
			$nextContainer = $(data.next.container),
			$elementorSections = $nextContainer.find('.elementor-section'),
			$cf7Forms = $nextContainer.find('.wpcf7-form'),
			event = document.createEvent('MutationEvents');

		if (window.theme.ajax.loadMissingScripts || window.theme.updateScriptNodes) {
			promises.push(PJAXUpdateScripts(data));
		}

		if (window.theme.ajax.loadMissingStyles) {
			promises.push(PJAXUpdateStyles(data));
		}

		// refresh page wrapper selectors
		window.$pageWrapper = $nextContainer;

		// Prepare ready event
		event.initMutationEvent('DOMContentLoaded', true, true, document, "", "", "", 0);

		return Promise
			.all(promises)
			.then(() => document.fonts.ready)
			.then(function () {

				// Elementor Pro sticky effects handling
				TweenMax.set($elementorSections, {
					clearProps: 'all',
					className: '-=elementor-sticky--active'
				});
				$nextContainer.find('.elementor-sticky__spacer').remove();

				// Elementor Animated Headline reset
				$nextContainer.find('.elementor-headline-animation-type-typing .elementor-headline-dynamic-wrapper').empty();

				// Elementor Pro Lottie animations reset
				$nextContainer.find('.e-lottie__animation').empty();

				// re-init Contact Form 7 Conditional Fields plugin
				if ($cf7Forms.length && typeof wpcf7cf === 'object' && typeof wpcf7cf.initForm === 'function') {
					wpcf7cf.initForm($cf7Forms);
				}

				// clear & re-init ScrollMagic
				window.SMController.destroy(true);
				window.SMController = new ScrollMagic.Controller();

				// split text lines in new container
				doSplitText($nextContainer).then(setLines($nextContainer)).then(function () {

					// scroll to the top
					setTimeout(function () {
						scrollToVeryTop();
					}, 100);

					if (typeof window.elementorFrontend !== 'undefined') {
						elementorFrontend.init();
					}

					// Transition init new page event
					window.dispatchEvent(new CustomEvent('arts/barba/transition/init'));

					// re-init components
					initComponents($nextContainer, false);
					window.SMController.enabled(false);

					// fire ready event
					document.dispatchEvent(event);

					if (window.theme.ajax.evalInlineContainerScripts) {

						// eval inline scripts in the main container
						$nextContainer.find('script').each(function () {
							try {
								window.eval(this.text);
							} catch (error) {
								console.warn(error);
							}
						});

					}

					// update ad trackers
					PJAXUpdateTrackers();

				});

				// change header color if needed
				switch (data.next.namespace) {
					case 'light': {
						window.$header.removeClass('header_white').addClass('header_black');
						break;
					}
					case 'dark': {
						window.$header.removeClass('header_black').addClass('header_white');
						break;
					}
				}

				$nextContainer.removeClass('page-wrapper_hidden');

				resolve(true);
			})
			.catch((e) => {
				barba.force(data.next.url.href);
				console.warn(e);
			});

	});

}
